export default "__VITE_ASSET__D$Gb4mfB__"